import request from '@/common/api'
import { HOSTS } from '@/common/utils/env'
import { selector, useRecoilValueLoadable, atom, useSetRecoilState } from 'recoil'

export enum ENT_FUCNTION_CODE_ENUM {
  RULE_PERIOD = 'budgetExpirySwitch',
  COST_CENTER = 'costCenterSwitch',
  EXPENSE_CODE = 'expenseCodeSwitch',
}

// 使用枚举作为键的类型
export type EntFunctionsConfigRes = {
  [key in ENT_FUCNTION_CODE_ENUM]: { code: string; name: string; open: boolean };
}

const FETCH_KEY = '/api/entweb/ent/functions'

// 刷新触发器
const refreshTrigger = atom({
  key: `${FETCH_KEY}_refresh_trigger`,
  default: 0,
})

const getData = selector({
  key: FETCH_KEY,
  get: async ({ get }) => {
    get(refreshTrigger)
    const data = await request.get(`${HOSTS.BASE}${FETCH_KEY}`)
    return data as EntFunctionsConfigRes
  },
})

const entFunctionConfigAtom = {
  useRefresh: () => {
    const setRefreshTrigger = useSetRecoilState(refreshTrigger)
    return () => {
      setRefreshTrigger(count => count + 1)
    }
  },
  useData: () => {
    const loadable = useRecoilValueLoadable(getData)
    return loadable.state === 'hasValue' ? loadable.contents : null
  },
}

export default entFunctionConfigAtom
